require('./cardStatementsView.scss');
const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');

// @actions
const cardsStatementsActions = require('actions/getCardsStatements');

// @components
const CardStatements = require('components/cards/cardStatements/cardStatements');
const LastStatementBox = require('components/cards/cardStatements/lastStatementBox/lastStatementBox');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CardHeaderDetails = require('components/cards/cardHeaderDetails/cardHeaderDetails');
const WebappRender = require('components/conditionalRender/webappRender')

// @utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
const { PAGE_GENERIC, recordPath } = require('utilities/tagging');
const { conditionalClassName, contactCenterClassName } = require('utilities/conditionals/conditionalClassname')

class CardStatementsView extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { cardId } }, immCards } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_STATEMENT_MOVEMENTS, { immCard }, history);
        this.props.requestCardStatements(cardId);

        const tagging = immCard.get('tagging');
        recordPath('tarjeta/extractos', PAGE_GENERIC, '', '', tagging);
    }

    render() {
        const {
            immCards,
            immScreen,
            immStatements,
            match: { params: { cardId } },
            requestCardMoreStatements,
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);
        const immCardStatements = immStatements.get(cardId);

        let block;
        if (immCard && immCardStatements) {
            const type = immCard.get('type');
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: immCard.get('alias').get('current'),
                    url: `/myprofile/cards/${cardId}/movements`
                },
                {
                    text: formatText('cardStatement-statements')
                }
            ];

            const titleKey = immCard.get('isViaT') ? 'cardStatement-cardStatementsViaT' : 'cardStatement-cardStatements';

            const lastStatementBoxClassName = conditionalClassName('hidden-xs hidden-sm hidden-md', 'card-statements-container__last-statement-box col-xs-4', 'col-lg-4')
            const cardStatementContainer = contactCenterClassName('card-statements-container__card-statements col-xs-8', 'col-md-12 col-lg-8')

            block = (
                <div>
                    <div className="container-fluid">
                        <div className="row">
                            <OKCover size="medium" section="cards" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={getFinalTitle(titleKey)}>
                                    <CardHeaderDetails immCard={immCard} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                {/* >> CONTENT DUPLICATED: REF-01 */}
                                <WebappRender>
                                    <div className="col-md-12 hidden-lg grid-view--fix-cell-separation-bottom">
                                        <LastStatementBox
                                            immStatements={immCardStatements}
                                            cardId={cardId}
                                        />
                                    </div>
                                </WebappRender>
                                {/* CONTENT DUPLICATED: REF-01 << */}
                                <div className={cardStatementContainer}>
                                    <CardStatements
                                        cardId={cardId}
                                        immScreen={immScreen}
                                        immStatements={immCardStatements}
                                        requestCardMoreStatements={requestCardMoreStatements}
                                    />
                                </div>
                                {/* >> REF-01 */}
                                <div className={lastStatementBoxClassName}>
                                    <LastStatementBox
                                        immStatements={immCardStatements}
                                        cardId={cardId}
                                    />
                                </div>
                                {/* REF-01 << */}
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardStatementsView.propTypes = {
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immScreen: PropTypes.object.isRequired,
    immStatements: PropTypes.object.isRequired,
    requestCardMoreStatements: PropTypes.func.isRequired,
    requestCardStatements: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = CardStatementsView;
module.exports.CardStatementsView = connect(
    state => ({
        immCards: state.cards,
        immScreen: state.screen,
        immStatements: state.cardsStatements
    }), {
    requestCardMoreStatements: cardsStatementsActions.requestCardMoreStatements,
    requestCardStatements: cardsStatementsActions.requestCardStatements,
})(withRouter(CardStatementsView));
